import { RecordKey, gatherBy } from "./gatherBy";

export function groupBy<T extends object, K extends keyof T>(
  array: readonly T[],
  key: K
): Record<T[K], T[]>;

export function groupBy<T>(
  array: readonly T[],
  path: readonly RecordKey[]
): Record<RecordKey, T[]>;

export function groupBy<T>(
  array: readonly T[],
  genKey: (elem: T) => RecordKey
): Record<RecordKey, T[]>;

export function groupBy<T>(
  array: readonly T[],
  pathOrFn: any
): Record<RecordKey, T[]> {
  const gatherFn = (
    result: Record<RecordKey, T[]>,
    key: RecordKey,
    element: T
  ) => {
    if (!(key in result)) result[key] = [];
    result[key]!.push(element);
  };
  return gatherBy(array, pathOrFn, gatherFn);
}
